
export default function Footer() {
  return (
    <footer className="py-4 md:py-12 px-6 bg-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-8 text-center">
          <div className="text-xs md:text-sm font-light text-gray-500">
            © 2026 <span className="font-medium">BAILA BAILA</span> <span className="opacity-80">MOVE</span>. All rights reserved.
          </div>
          
          <a
            href="https://judicious-hail-b74.notion.site/MOVE-CREATOR-2fee6598049d8069ae88f28fc64c270b"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-light text-gray-700 hover:text-gray-900 transition-colors cursor-pointer underline underline-offset-4"
          >
            ムーブクリエーターについて
          </a>
        </div>
      </div>
    </footer>
  );
}
